import Posthog, { Properties } from 'posthog-js'
import { Config } from '..'
function _capture(name: string, data: Properties) {
  console.log('Posthog.__loaded', Posthog.__loaded)
  if (!Posthog.__loaded) return false
  console.log('Posthog.capture', name, data)
  Posthog.capture(name, data)
  return true
}

export function initialize(config: Config) {
  if (!config.enable) {
    console.log('PostHog is not initialized.')
    return
  }
  const cfg = {
    api_key: config.apiKey,
    api_host: 'https://eu.posthog.com',
  } as const
  if (!cfg.api_key) throw new Error('PostHog API key is missing.')
  Posthog.init(cfg.api_key, { api_host: cfg.api_host, autocapture: false })
}

export function isInitialized() {
  return Posthog.__loaded
}

export function optIn() {
  Posthog.opt_in_capturing()
}

export function optOut() {
  Posthog.opt_out_capturing()
}

export function getDistinctId() {
  return Posthog.get_distinct_id()
}

export function capture(name: string, data: Properties) {
  if (_capture(name, data)) return
  const interval = setInterval(() => {
    if (_capture(name, data)) clearInterval(interval)
  }, 100)
}

export default Posthog
